var path = '/client/common/modules/media-picker/views/partials/media-picker-details-empty.html';
var html = "<!-- Media picker details empty -->\n<div class=\"media-picker-details-empty\" >\n    <span>{{ ::'FRONT.MEDIA_PICKER.MEDIA_FOLDER_EMPTY' | trans }}</span>\n</div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;